
import { createSelector } from '@ngrx/store';
import { AppState } from 'src/app/app.reducer';
import { Aplicacion, UsuarioRedux } from '../../models/usuario.model';
import { Ambiente } from 'src/app/modulos/catalogos-proces/models/ambiente';
import { Rol } from 'src/app/modulos/admin/models/rol';

export const currentUser = (state: AppState) => state.usuarioApp.currentUser;
export const ambienteSeleccionado = (state: AppState) => state.globalApp.ambienteSeleccionado;
export const elementosNivelesPermisos = (state: AppState) => state.globalApp.elementosNivelesPermisos;
export const rolSeleccionado = (state: AppState) => state.globalApp.rolSeleccionado;

//Función que permite obtener del Store todas las aplicaciones a las que el usuario tiene asignado por rol y ambiente
//Ejemplo de retorno de la función  [{rol: "ADMINISTRADOR", ambiente: "COMANDO GENERAL", app: "OBJETIVOS"}, {rol: "ADMINISTRADOR", ambiente: "SUBCOMANDO GENERAL", app: "OBJETIVOS"}]
export const getAplicacionesUsuarioPorAmbiente = createSelector(
  currentUser,
  ambienteSeleccionado,
  rolSeleccionado,
  (user: UsuarioRedux, ambienteSeleccionado: Ambiente, rolSeleccionado) => {
    //let rol: Rol = user.roles.find(({ ambiente }) => ambiente.idSprAmbiente === ambienteSeleccionado.idSprAmbiente)
    if (rolSeleccionado) {
      return rolSeleccionado.aplicaciones as Partial<Aplicacion[]>
    } else {
      return null;
    }
  }
);

export const getAmbienteSelecionado = createSelector(
  elementosNivelesPermisos,
 
  ( elementosNivelesPermisos: any) => {
    //let rol: Rol = user.roles.find(({ ambiente }) => ambiente.idSprAmbiente === ambienteSeleccionado.idSprAmbiente)
    if (elementosNivelesPermisos) {
      return elementosNivelesPermisos as Partial<any>
    } else {
      return null;
    }
  }
);


export const tieneAplicacionUsuarioPorAmbiente = createSelector(
  currentUser,
  ambienteSeleccionado,
  rolSeleccionado,
  (user: UsuarioRedux, ambienteSeleccionado: Ambiente, rolSeleccionado:Rol ,props) => {
    //let rol: Rol = user.roles.find(({ ambiente }) => ambiente.idSprAmbiente === ambienteSeleccionado.idSprAmbiente)
    if (rolSeleccionado) {      
      for (let i = 0; i < rolSeleccionado.aplicaciones.length; i++) {
        for (let j = 0; j < props.app.length; j++) {   
          if (rolSeleccionado.aplicaciones[i].idSprAplicacion === props.app[j]) {
            return true;
          }
        }
      }
    }
    return false;
  }
);


export const tieneRolId = createSelector(
  currentUser,  
  (user: UsuarioRedux, props) => {
    let rol: Rol = user.roles.find(({ idSprRol }) => props.idSprRol === idSprRol)
    if (rol) {      
      return true;
    }
    return false;
  }
);

